import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import TitleBar from '../../../../../../components/LazyWidgets/TitleBar';
import Button from '../../../../../../components/LazyWidgets/Button';
import { Slide } from '../../../../../../components/dashboard/components';
import MLDialog from '../../../../../../components/MLDialog/MLDialog';
import MLButton from '../../../../../../components/MLButton';
import { REPORTS_TAB } from '../../../../lib/constants';
import { REPORT_TYPE_INSIGHTS_LO } from '../../../../../actions/constants';

import {
  VIEW_QQ_INSIGHTS_LO_MODAL,
  VIEW_QQ_INSIGHTS_ASSIGNMENT_MODAL,
  CLICK_LO_MODAL_VIEW_UNIT_BUTTON,
} from '../../../../../analyticsEvents';

import style from './FullScreenModal.module.css';

const QQInsightDetailsModal = ({
  title,
  subTitle,
  iconType,
  children,
  onTabChange,
  lastFetchedAt,
  isInsightDetailModalVisible,
  toggleInsightDetailsModal,
  sendAnalyticsEvent,
  reportType,
  activeUnit,
  trackAnalytics,
}) => {
  const [isOpen, setOpen] = useState(true);
  const id = activeUnit && activeUnit.id;

  // Log a page view when the modal becomes visible
  if (trackAnalytics) {
    useEffect(() => {
      if (isInsightDetailModalVisible) {
        const analyticsData = reportType === REPORT_TYPE_INSIGHTS_LO ?
          VIEW_QQ_INSIGHTS_LO_MODAL :
          VIEW_QQ_INSIGHTS_ASSIGNMENT_MODAL;
        sendAnalyticsEvent(analyticsData);
      }
    }, [isInsightDetailModalVisible]);
  }
  const isLOReport = reportType === REPORT_TYPE_INSIGHTS_LO;
  const actions = [
    <div className={style.lastUpdated}>
      Updated: {moment(lastFetchedAt).format('MMM Do, h:mm A')}
    </div>,
  ];

  if (isLOReport) {
    actions.unshift(
      <MLButton
        btnType="secondary"
        actionClassName={style.viewReport}
        onClick={() => {
          toggleInsightDetailsModal(reportType);
          onTabChange(`reports/type/unit/${id}?activeTab=${REPORTS_TAB}`);
          sendAnalyticsEvent(CLICK_LO_MODAL_VIEW_UNIT_BUTTON);
        }}
        testId="btn_view_full_report"
      >
        View Full Unit Report
      </MLButton>
    );
  }

  const Title = ({ onClick }) => (
    <TitleBar title={title} subTitle={subTitle} icon={iconType} className={style.TitleBar}>
      <Button
        onClick={() => {
          setOpen(false);
          setTimeout(onClick, 600);
        }} theme="secondary" style={{ marginLeft: 'auto' }}
      >
        Close
      </Button>
    </TitleBar>
  );

  Title.propTypes = {
    onClick: PropTypes.func,
  };

  return (
    <MLDialog
      className={style.modalWindow}
      bodyClassName={style.modalBody}
      overlayClassName={style.modalOverlay}
      titleClassName={style.modalTitle}
      show={isInsightDetailModalVisible}
    >
      <Slide duration={400} isActive={isOpen}>
        <div className={style.slideContentContainer}>
          <Title
            onClick={() => toggleInsightDetailsModal(reportType)}
          />
          <div className={style.ReportPage}>
            {children}
          </div>
        </div>
      </Slide>
    </MLDialog>
  );
};

QQInsightDetailsModal.defaultProps = {
  trackAnalytics: true,
};

QQInsightDetailsModal.propTypes = {
  children: PropTypes.node.isRequired,
  activeUnit: PropTypes.object,
  isInsightDetailModalVisible: PropTypes.bool.isRequired,
  toggleInsightDetailsModal: PropTypes.func,
  onTabChange: PropTypes.func,
  sendAnalyticsEvent: PropTypes.func,
  trackAnalytics: PropTypes.bool,
  handleClose: PropTypes.func,
  lastFetchedAt: PropTypes.object,
  title: PropTypes.string,
  subTitle: PropTypes.string,
  iconType: PropTypes.string,
  reportType: PropTypes.string,
};

export default QQInsightDetailsModal;
